import React from "react";
import { useLoader } from "../../context/LoaderContext";
import "../../styles/GlobalLoader.css";

const GlobalLoader = () => {
  const { loading } = useLoader();

  if (!loading) return null;

  return (
    <div className="overlay">
      <img src="/hl-loading-logo.png" alt="Logo" className="logo" />
      <div></div>
    </div>
  );
};

export default GlobalLoader;
